import __vue_component__ from '../Button/Button.vue.js';
import { chunk } from '../../utils/utils.js';

//
const HALF_DECADE = 5;
var script = {
  name: 'Years',
  components: {
    Button: __vue_component__
  },
  props: {
    yearsOfDecade: {
      type: Array,
      required: true
    }
  },
  computed: {
    decade() {
      return chunk(this.yearsOfDecade, HALF_DECADE);
    }

  },
  methods: {
    onYearSelected(year) {
      this.$emit('year-selected', year);
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Calendar/Years.vue_rollup-plugin-vue=script.js